import { render, staticRenderFns } from "./BFieldWrapper.vue?vue&type=template&id=3477a486"
import script from "./BFieldWrapper.vue?vue&type=script&lang=ts"
export * from "./BFieldWrapper.vue?vue&type=script&lang=ts"
import style0 from "./BFieldWrapper.vue?vue&type=style&index=0&id=3477a486&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports